module.exports = __webpack_public_path__ + "static/media/alert.5a5542a3.mp3";